export type InvoiceSettings = {
  invoiceTypeName: invoiceTypeName
  scheduleTypeName: scheduleTypeName
  groupingReferenceId: number
  groupingInvoiceTypeName: groupingInvoiceTypeName
  externalReference?: string
  startDate: string
  isVATable: boolean
  shouldSendEmail: boolean
}

export enum invoiceTypeName {
  Agent_Individual = 'Individual (Agent)',
  Managed_Individual = 'Individual (Managed)',
  Consolidated = 'Consolidated',
  Platform_Individual = 'Platform Individual',
  Platform_Consolidated = 'Platform Consolidated',
}

export enum scheduleTypeName {
  Weekly = 'Weekly',
  Monthly = 'Monthly',
  Fortnightly = 'Fortnightly',
  FourWeekly = '4 Weekly',
  Daily = 'Daily',
}

export enum groupingInvoiceTypeName {
  Indivudual_Invoices = 'Single Invoice per Reference',
  Indivudual_Invoice_Lines = 'Line Item per Reference',
}
